import api from './client';

const BASE = '/api/suppliers';

export async function fetchSuppliers(params = {}, config = {}) {
  const { data } = await api.get(BASE, { params, ...config });
  return Array.isArray(data) ? data : [];
}

export async function fetchSupplierById(id, config = {}) {
  const { data } = await api.get(`${BASE}/${id}`, config);
  return data;
}

export async function createSupplier(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updateSupplier(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function deleteSupplier(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}
